module.exports = __webpack_public_path__ + "static/media/brillumex-1.8d608601.jpg";